<template>
  <div class="flex -mx-3">
    <div class="flex-1 px-3">
      {{ $t('name') | capitalize }}
    </div>
    <div class="flex-1 px-3">
      {{ $t('global.product') | capitalize }}
    </div>
    <div class="w-24 px-3 text-right">
      {{ $t('price') | capitalize }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataIteratHeader',
};
</script>
